<template>
  <div class="col-xs-12 col-sm-12 offset-md-1 col-md-10">
    <el-divider class="divider-green"></el-divider>

    <div class="row d-flex justify-content-between align-items-center">
      <div class="block">
        <h2>Audit Log</h2>
        <p v-show="this.auditLog.length > 0">
          Displaying {{ this.auditLog.length }} logs of {{ this.totalAuditLogCount }}
        </p>
      </div>
      <div class="row d-flex align-items-center">
        <div>
          <base-button @click="exportPDF()" class="btn-dark float-sm-none float-md-left">Export PDF</base-button>
        </div>
        <div style="width: 300px; padding-left:20px">
          <el-input :disabled="!this.isOrderIdAvailable" @input="searchInput()" v-model="search"
            placeholder="Type to search" />
        </div>
      </div>
    </div>
    <br />

    <div class="block">

      <br />
      <el-timeline v-if="auditLog && auditLog.length && this.isOrderIdAvailable">
        <el-timeline-item v-for="(item, index) in auditLog" :timestamp="item.logDate | formatDateTime" :key="index"
          placement="top">
          <el-card shadow="never">
            <div class="row">
              <div class="col-md-12">
                <el-table :data="[item]" role="table" aria-label="Audit Logs Table">
                  <el-table-column prop="updateBy" label="Update By" scope="col">
                  </el-table-column>
                  <el-table-column prop="action" label="Action" scope="col">
                  </el-table-column>
                  <el-table-column prop="fieldNames" label="Field Name" scope="col">
                  </el-table-column>
                  <el-table-column label="Previous Value" scope="col">
                    <template slot-scope="scope">
                      <AuditSignature v-if="(
          scope.row.fieldNames.includes('Signature') ||
          scope.row.fieldNames.includes('RequestorSignature') ||
          scope.row.fieldNames.includes('AcceptorSignature') ||
          scope.row.fieldNames.includes('ReceiverSignature') ||
          scope.row.fieldNames.includes('SupplierSignature') ||
          scope.row.fieldNames.includes('FinanceSignature')
        ) &&
          scope.row.oldValues
          " :signature-data="scope.row.oldValues" />
                      <p v-else>{{ scope.row.oldValues }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="Current Value">
                    <template slot-scope="scope">
                      <AuditSignature v-if="(
          scope.row.fieldNames.includes('Signature') ||
          scope.row.fieldNames.includes('RequestorSignature') ||
          scope.row.fieldNames.includes('AcceptorSignature') ||
          scope.row.fieldNames.includes('ReceiverSignature') ||
          scope.row.fieldNames.includes('SupplierSignature') ||
          scope.row.fieldNames.includes('FinanceSignature')
        ) &&
          scope.row.newValues
          " :signature-data="scope.row.newValues" />
                      <p v-else>{{ scope.row.newValues }}</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-card>
        </el-timeline-item>
        <div class="text-center pt-4">

          <base-button v-if="auditLog.length < totalAuditLogCount" @click="loadMoreAuditLogs()" type="primary">Show More</base-button>
        </div>
      </el-timeline>
      <el-card v-else>
        <div class="text-center pt-4">
          <h2>
            {{ auditLogLoadingText }}
          </h2>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Divider,
  Tag,
  Card,
  Timeline,
  TimelineItem,
} from "element-ui";

import { mapActions, mapGetters } from "vuex";
import Util from "@/util/util";
import axios from '@/axios';
import AuditSignature from "@/components/App/signatures/AuditSignature";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    [Card.name]: Card,
    AuditSignature,
  },
  data() {
    return {
      search: "",
      resultsCount: 10,
    };
  },
  watch: {
    async activeTab(newTab, oldTab) {
      if (newTab == "AuditLog") {
        await this.loadAuditLogData();
      }
    },
  },
  filters: {
    formatDateTime(value) {
      if (!value) return "";
      return value;
    },
  },
  computed: {
    ...mapGetters({
      auditLogLoadingText: "auditLog/auditLogLoadingText",
      auditLog: "auditLog/getAuditLog",
      totalAuditLogCount: "auditLog/getTotalAuditLogCount",
      orderIdFromPreOrderDetail: "preOrderDetail/preOrder",
      activeTab: "tab/activeTab",

    }),
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    orderId() {
      if (this.isOrderIdAvailable && this.orderIdFromRoute !== 0) {
        return this.orderIdFromRoute;
      } else {
        return this.orderIdFromPreOrderDetail.orderId;
      }
    },
    isOrderIdAvailable() {
      return (
        this.orderIdFromRoute != 0 ||
        (this.orderIdFromRoute != 0 &&
          this.orderIdFromPreOrderDetail &&
          this.orderIdFromPreOrderDetail.orderId != 0)
      );
    },
  },
  methods: {
    ...mapActions({
      fetchAuditLog: "auditLog/fetchAuditLog",
      fetchAuditLogPagination: "auditLog/fetchAuditLogPagination"
    }),
    async loadAuditLogData(pageNumber, isclear = false) {
      if (this.isOrderIdAvailable) {
        // await  this.fetchAuditLog(this.orderId);

        // same way to pass apiInfor to the search, there is no export flag
        let apiInfo = {
          orderId: this.orderId,
          pageNumber: pageNumber ? pageNumber : 1,
          resultsPerPage: this.resultsCount,
          searchText: this.search,
          isClear: isclear
        };
        await this.fetchAuditLogPagination(apiInfo);
      }
    },
    async loadMoreAuditLogs() {
      this.$loaderApp.addRequest();
      let pageNo = this.auditLog.length / this.resultsCount + 1
      this.pageNumber = pageNo < 1 ? 1 : pageNo

      await this.loadAuditLogData(this.pageNumber)
      this.$loaderApp.completeRequest();

    },


    async searchInput() {
      this.$loaderApp.addRequest();
      let pageNo = this.auditLog.length / this.resultsCount
      this.pageNumber = pageNo < 1 ? 1 : pageNo

      await this.loadAuditLogData(this.pageNumber, true)
      this.$loaderApp.completeRequest();

    },

    exportPDF() {
      this.$loaderApp.addRequest();
      axios({
        url: `/api/auditlogs/excel/${this.orderId}/${this.search}`,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        Util.fileDownload(response.data, `Audit_Log_Summary_${this.orderId}.pdf`);
        this.$loaderApp.completeRequest();
      }).catch((error) => {
        this.$loaderApp.completeRequest();
        this.$toast.error(error);

      });
    },
  },
};
</script>

<style>
.row .search-box {
  margin-bottom: 5em;
}

.divider-green {
  background-color: #10b45a;
}

.el-table--border {
  border: 1px solid rgba(34, 42, 66, 0.2);
}

ul.el-timeline {
  padding-inline-start: 0;
}
</style>
